import React, { useCallback, useState } from "react";

import { type ButtonProps } from "@/components/ui/Button";

import { BusyButton } from "./BusyButton";

export type ButtonLoaderProps = {
  onClick: () => Promise<unknown>;
  className?: string;
  variant?: ButtonProps["variant"];
  /** See {@link BusyButton}: for the admin app only */
  keepFocus?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

/** A button that stays disabled and busy while its async action runs; the caller shows any error. */
export const ButtonLoader = (props: ButtonLoaderProps) => {
  const { onClick: _onClick, ...otherProps } = props;

  const [isLoading, setLoading] = useState(false);

  const onClick = useCallback(() => {
    setLoading(true);
    // in case a non-async-fn was passed (e.g. spies in tests pass through type checks), the return value is wrapped with a promise
    void Promise.resolve(_onClick()).finally(() => setLoading(false));
  }, [_onClick]);

  return <BusyButton onClick={onClick} busy={isLoading} {...otherProps} />;
};
